"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import { Avatar } from "@/elements"
import Link from "next/link"

const ReceivedReferralRequestFragment = graphql(`
  fragment NotificationActor on Actor {
    __typename
    id
    name
    avatar120w: avatar(width: 120)
    avatarInitials
  }
`)

interface Props {
  actor: FragmentType<typeof ReceivedReferralRequestFragment>
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
}

export const NotificationActor: React.FC<Props> = ({ onActorClick, ...props }) => {
  const actor = useFragment(ReceivedReferralRequestFragment, props.actor)

  return (
    <div onClick={e => onActorClick(e)}>
      <Avatar size="sm" src={actor?.avatar120w} initials={actor?.avatarInitials} />
    </div>
  )
}
